import { useCallback, useEffect } from 'react'
import useQuestionSettingsField from '@v4/hooks/questions/useQuestionSettingsField'
import AppStore from '@v4/store/appStore'
import ScorecardSelector from '@v4/utils/selectors/ScorecardSelector'
import QuizQuestionsSelector from '@v4/utils/selectors/QuizQuestionsSelector'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'

export const usePlaceholder = ({ onClick, pending, justify, questionId }) => {
	const { updateQuestionSettings } = QuizQuestionsSelector.useActions()
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const buttonLabel = useQuestionSettingsField('button_label')
	const isQuestionBuilderMode = PageBuilderSelector.useIsQuestionsMode()
	const locked = ScorecardSelector.useIsQuestionsLocked()

	const handleButtonChange = useCallback(
		value => {
			updateQuestionSettings({
				id: questionId,
				settings: {
					button_label: value,
				},
			})
		},
		[questionId, updateQuestionSettings],
	)

	const handleSubmit = useCallback(() => {
		onClick()
	}, [onClick])

	useEffect(() => {
		const handleKeyUp = ({ key }) => {
			if (key === 'Enter') {
				handleSubmit()
			}
		}

		document.addEventListener('keyup', handleKeyUp)
		return () => {
			document.removeEventListener('keyup', handleKeyUp)
		}
	}, [handleSubmit])

	return [
		{
			pending,
			justify,
			buttonLabel: buttonLabel || ' ',
			editable: !locked && isBuilderMode && isQuestionBuilderMode,
		},
		{ handleSubmit, handleButtonChange: isBuilderMode ? handleButtonChange : undefined },
	]
}
